import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Header() {
  const navItems = [
    { name: 'About', path: '/about' },
    { name: 'Games', path: '/my-games' },
  ];

  return (
    <header className="w-full top-0 z-50">
      {/* Site Header */}
      <div className="relative overflow-hidden" style={{ background: '#1E0533', border: '4px solid #0F0A1A', borderRadius: '4px', boxShadow: '8px 8px 0 #0F0A1A' }}>
        {/* Background gradients */}
        <div className="absolute inset-0" style={{
          background: `
            radial-gradient(ellipse at 20% 50%, rgba(88,28,135,0.6) 0%, transparent 60%),
            radial-gradient(ellipse at 80% 30%, rgba(107,33,168,0.4) 0%, transparent 50%),
            radial-gradient(ellipse at 60% 80%, rgba(253,224,71,0.1) 0%, transparent 40%)
          `,
          zIndex: 0,
        }}></div>

        {/* Halftone background pattern */}
        <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.06) 1.5px, transparent 1.5px)',
          backgroundSize: '18px 18px',
          zIndex: 0,
        }}></div>

        {/* Speed lines */}
        <div className="absolute top-0 right-0 bottom-0" style={{
          width: '45%',
          background: `repeating-linear-gradient(
            -15deg,
            transparent,
            transparent 8px,
            rgba(253,224,71,0.04) 8px,
            rgba(253,224,71,0.04) 9px
          )`,
          zIndex: 0,
        }}></div>

        <div className="relative z-10 container mx-auto px-4 py-3 md:py-4">
          {/* Mobile: Two rows layout */}
          <div className="md:hidden">
            {/* Row 1: Logo + Menu Buttons */}
            <div className="flex items-center justify-between mb-2">
              {/* Left: Avatar + Logo */}
              <div className="flex items-center gap-2">
                {/* Avatar Frame with Comic Burst Ring */}
                <div className="relative w-24 h-24">
                  {/* Comic burst ring */}
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
                    className="absolute inset-0 rounded-full"
                    style={{
                      background: `conic-gradient(
                        #FDE047 0deg, #FDE047 20deg,
                        #0F0A1A 20deg, #0F0A1A 22deg,
                        #A855F7 22deg, #A855F7 42deg,
                        #0F0A1A 42deg, #0F0A1A 44deg,
                        #FDE047 44deg, #FDE047 64deg,
                        #0F0A1A 64deg, #0F0A1A 66deg,
                        #EF4444 66deg, #EF4444 86deg,
                        #0F0A1A 86deg, #0F0A1A 88deg,
                        #FDE047 88deg, #FDE047 108deg,
                        #0F0A1A 108deg, #0F0A1A 110deg,
                        #A855F7 110deg, #A855F7 130deg,
                        #0F0A1A 130deg, #0F0A1A 132deg,
                        #FDE047 132deg, #FDE047 152deg,
                        #0F0A1A 152deg, #0F0A1A 154deg,
                        #EF4444 154deg, #EF4444 174deg,
                        #0F0A1A 174deg, #0F0A1A 176deg,
                        #FDE047 176deg, #FDE047 196deg,
                        #0F0A1A 196deg, #0F0A1A 198deg,
                        #A855F7 198deg, #A855F7 218deg,
                        #0F0A1A 218deg, #0F0A1A 220deg,
                        #FDE047 220deg, #FDE047 240deg,
                        #0F0A1A 240deg, #0F0A1A 242deg,
                        #EF4444 242deg, #EF4444 262deg,
                        #0F0A1A 262deg, #0F0A1A 264deg,
                        #FDE047 264deg, #FDE047 284deg,
                        #0F0A1A 284deg, #0F0A1A 286deg,
                        #A855F7 286deg, #A855F7 306deg,
                        #0F0A1A 306deg, #0F0A1A 308deg,
                        #FDE047 308deg, #FDE047 328deg,
                        #0F0A1A 328deg, #0F0A1A 330deg,
                        #EF4444 330deg, #EF4444 350deg,
                        #0F0A1A 350deg, #0F0A1A 352deg,
                        #FDE047 352deg, #FDE047 360deg
                      )`,
                      zIndex: -1,
                    }}
                  />
                  {/* Avatar image */}
                  <motion.div
                    animate={{ translateY: [0, -6, 0], rotate: [-2, 2, -2], scale: [1, 1.05, 1] }}
                    transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
                    className="absolute inset-3.5 rounded-full overflow-hidden border-3 border-black flex items-center justify-center text-3xl font-bold"
                    style={{
                      boxShadow: '0 0 15px rgba(168,85,247,0.8), 3px 3px 0 #000',
                    }}
                  >
                    <img 
                      src="/images/profile.png" 
                      alt="AI Gaming Girl Avatar"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  </motion.div>
                </div>

                {/* Logo */}
                <Link to="/" className="flex flex-col">
                  <h1 className="leading-tight" style={{ fontFamily: "'Bangers', cursive", fontSize: '26px', letterSpacing: '0.5px', lineHeight: '1.1', color: '#FDE047', WebkitTextStroke: '0.8px #0F0A1A', textShadow: '1px 1px 0 #3B0764, 2px 2px 0 #0F0A1A', whiteSpace: 'nowrap' }}>
                    <span style={{ color: '#EF4444', WebkitTextStroke: '0.8px #0F0A1A' }}>AI</span> Gaming<br />
                    <span style={{ color: '#E879F9', WebkitTextStroke: '0.8px #0F0A1A' }}>✨ Girl ✨</span>
                  </h1>
                </Link>
              </div>

              {/* Right: Navigation - Vertical on mobile */}
              <nav className="flex flex-col gap-1.5 items-center" style={{ background: 'transparent' }}>
                <Link
                  to="/"
                  className="text-center py-2 px-4 font-bold transition-all w-28"
                  style={{ fontFamily: "'Bangers', cursive", fontSize: '14px', color: '#0F0A1A', textDecoration: 'none', letterSpacing: '1px', textTransform: 'uppercase', background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)', border: '2px solid #0F0A1A', borderRadius: '6px', boxShadow: '2px 2px 0 #0F0A1A', fontWeight: '900' }}
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  className="text-center py-2 px-4 font-bold transition-all w-28"
                  style={{ fontFamily: "'Bangers', cursive", fontSize: '14px', color: '#0F0A1A', textDecoration: 'none', letterSpacing: '1px', textTransform: 'uppercase', background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)', border: '2px solid #0F0A1A', borderRadius: '6px', boxShadow: '2px 2px 0 #0F0A1A', fontWeight: '900' }}
                >
                  About
                </Link>
                <Link
                  to="/my-games"
                  className="text-center py-2 px-4 font-bold transition-all w-28"
                  style={{ fontFamily: "'Bangers', cursive", fontSize: '14px', color: '#0F0A1A', textDecoration: 'none', letterSpacing: '1px', textTransform: 'uppercase', background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)', border: '2px solid #0F0A1A', borderRadius: '6px', boxShadow: '2px 2px 0 #0F0A1A', fontWeight: '900' }}
                >
                  Games
                </Link>
              </nav>
            </div>
          </div>

          {/* Desktop: Original layout */}
          <div className="hidden md:grid md:grid-cols-[auto_1fr_auto] gap-8 lg:gap-12 items-center">
            {/* Left: Avatar + Logo */}
            <div className="flex items-center gap-2 md:gap-4 justify-center md:justify-start">
              {/* Avatar Frame with Comic Burst Ring */}
              <div className="relative w-24 h-24 md:w-40 md:h-40">
                {/* Comic burst ring */}
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
                  className="absolute inset-0 rounded-full"
                  style={{
                    background: `conic-gradient(
                      #FDE047 0deg, #FDE047 20deg,
                      #0F0A1A 20deg, #0F0A1A 22deg,
                      #A855F7 22deg, #A855F7 42deg,
                      #0F0A1A 42deg, #0F0A1A 44deg,
                      #FDE047 44deg, #FDE047 64deg,
                      #0F0A1A 64deg, #0F0A1A 66deg,
                      #EF4444 66deg, #EF4444 86deg,
                      #0F0A1A 86deg, #0F0A1A 88deg,
                      #FDE047 88deg, #FDE047 108deg,
                      #0F0A1A 108deg, #0F0A1A 110deg,
                      #A855F7 110deg, #A855F7 130deg,
                      #0F0A1A 130deg, #0F0A1A 132deg,
                      #FDE047 132deg, #FDE047 152deg,
                      #0F0A1A 152deg, #0F0A1A 154deg,
                      #EF4444 154deg, #EF4444 174deg,
                      #0F0A1A 174deg, #0F0A1A 176deg,
                      #FDE047 176deg, #FDE047 196deg,
                      #0F0A1A 196deg, #0F0A1A 198deg,
                      #A855F7 198deg, #A855F7 218deg,
                      #0F0A1A 218deg, #0F0A1A 220deg,
                      #FDE047 220deg, #FDE047 240deg,
                      #0F0A1A 240deg, #0F0A1A 242deg,
                      #EF4444 242deg, #EF4444 262deg,
                      #0F0A1A 262deg, #0F0A1A 264deg,
                      #FDE047 264deg, #FDE047 284deg,
                      #0F0A1A 284deg, #0F0A1A 286deg,
                      #A855F7 286deg, #A855F7 306deg,
                      #0F0A1A 306deg, #0F0A1A 308deg,
                      #FDE047 308deg, #FDE047 328deg,
                      #0F0A1A 328deg, #0F0A1A 330deg,
                      #EF4444 330deg, #EF4444 350deg,
                      #0F0A1A 350deg, #0F0A1A 352deg,
                      #FDE047 352deg, #FDE047 360deg
                    )`,
                    zIndex: -1,
                  }}
                />
                {/* Avatar image */}
                <motion.div
                  animate={{ translateY: [0, -6, 0], rotate: [-2, 2, -2], scale: [1, 1.05, 1] }}
                  transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
                  className="absolute inset-4 rounded-full overflow-hidden border-4 border-black flex items-center justify-center text-4xl md:text-5xl font-bold"
                  style={{
                    boxShadow: '0 0 20px rgba(168,85,247,0.8), 0 0 40px rgba(168,85,247,0.4), 4px 4px 0 #000',
                  }}
                >
                  <img 
                    src="/images/profile.png" 
                    alt="AI Gaming Girl Avatar"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </motion.div>
              </div>

              {/* Logo */}
              <Link to="/" className="flex flex-col">
                <h1 className="leading-tight" style={{ fontFamily: "'Bangers', cursive", fontSize: 'clamp(32px, 6vw, 52px)', letterSpacing: '1px', lineHeight: '1.1', color: '#FDE047', WebkitTextStroke: '1px #0F0A1A', textShadow: '2px 2px 0 #3B0764, 3px 3px 0 #0F0A1A', whiteSpace: 'normal' }}>
                  <span style={{ color: '#EF4444', WebkitTextStroke: '1px #0F0A1A' }}>AI</span> Gaming<br />
                  <span style={{ color: '#E879F9', WebkitTextStroke: '1px #0F0A1A' }}>✨ Girl ✨</span>
                </h1>
              </Link>
            </div>

            {/* Center: Hero Section */}
            <div className="text-center hidden md:block">
              {/* Hero Title */}
              <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: 'clamp(20px, 3.5vw, 36px)', color: '#FFFBF0', WebkitTextStroke: '1px #0F0A1A', textShadow: '2px 2px 0 #0F0A1A', lineHeight: '1.2', marginBottom: '12px' }}>
                Building the <em style={{ color: '#FDE047', fontStyle: 'normal' }}>Future</em>,<br className="hidden md:block" />
                One Game at a <em style={{ color: '#FDE047', fontStyle: 'normal' }}>Time!</em>
              </h2>
              
              {/* Tags */}
              <div className="flex flex-wrap justify-center gap-3 items-center">
                <span style={{ fontFamily: "'Fredoka One', cursive", fontSize: 'clamp(12px, 2vw, 16px)', paddingLeft: '14px', paddingRight: '14px', paddingTop: '6px', paddingBottom: '6px', borderRadius: '8px', background: 'linear-gradient(135deg, #A855F7 0%, #9333EA 100%)', color: '#FFFFFF', fontWeight: '700', border: '2.5px solid #0F0A1A' }}>
                  🔌 IoT
                </span>
                <span style={{ fontFamily: "'Fredoka One', cursive", fontSize: 'clamp(12px, 2vw, 16px)', paddingLeft: '14px', paddingRight: '14px', paddingTop: '6px', paddingBottom: '6px', borderRadius: '8px', background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)', color: '#0F0A1A', fontWeight: '700', border: '2.5px solid #0F0A1A' }}>
                  🤖 AI
                </span>
                <span style={{ fontFamily: "'Fredoka One', cursive", fontSize: 'clamp(12px, 2vw, 16px)', paddingLeft: '14px', paddingRight: '14px', paddingTop: '6px', paddingBottom: '6px', borderRadius: '8px', background: 'linear-gradient(135deg, #34D399 0%, #10B981 100%)', color: '#0F0A1A', fontWeight: '700', border: '2.5px solid #0F0A1A' }}>
                  🎮 Fun Games
                </span>
              </div>
            </div>

            {/* Right: Navigation - Vertical Strip */}
            <nav className="flex flex-col gap-1 md:gap-3 items-center md:items-stretch md:min-w-max" style={{ background: 'transparent' }}>
              <Link
                to="/"
                className="text-center py-2 md:py-3 px-4 md:px-8 font-bold transition-all hover:scale-105 w-auto md:w-32 lg:w-40"
                style={{ fontFamily: "'Bangers', cursive", fontSize: 'clamp(12px, 2.5vw, 18px)', color: '#0F0A1A', textDecoration: 'none', letterSpacing: '2px', textTransform: 'uppercase', background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)', border: '3px solid #0F0A1A', borderRadius: '8px', boxShadow: '4px 4px 0 #0F0A1A', fontWeight: '900', cursor: 'pointer' }}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-center py-2 md:py-3 px-4 md:px-8 font-bold transition-all hover:scale-105 w-auto md:w-32 lg:w-40"
                style={{ fontFamily: "'Bangers', cursive", fontSize: 'clamp(12px, 2.5vw, 18px)', color: '#0F0A1A', textDecoration: 'none', letterSpacing: '2px', textTransform: 'uppercase', background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)', border: '3px solid #0F0A1A', borderRadius: '10px', boxShadow: '4px 4px 0 #0F0A1A', fontWeight: '900', cursor: 'pointer' }}
              >
                About
              </Link>
              <Link
                to="/my-games"
                className="text-center py-2 md:py-3 px-4 md:px-8 font-bold transition-all hover:scale-105 w-auto md:w-32 lg:w-40"
                style={{ fontFamily: "'Bangers', cursive", fontSize: 'clamp(12px, 2.5vw, 18px)', color: '#0F0A1A', textDecoration: 'none', letterSpacing: '2px', textTransform: 'uppercase', background: 'linear-gradient(135deg, #FDE047 0%, #FBBF24 100%)', border: '3px solid #0F0A1A', borderRadius: '8px', boxShadow: '4px 4px 0 #0F0A1A', fontWeight: '900', cursor: 'pointer' }}
              >
                Games
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
